import { render, staticRenderFns } from "./SoundPlayer.vue?vue&type=template&id=60525399&scoped=true&"
import script from "./SoundPlayer.vue?vue&type=script&lang=js&"
export * from "./SoundPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SoundPlayer.vue?vue&type=style&index=0&id=60525399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60525399",
  null
  
)

export default component.exports